<template>
  <div>
    <div
      v-for="(space, index) in parkingSpaces"
      :key="`parkingSpace-${index}`"
      @click="clickHandler(space)"
      :class="{ 'cursor-pointer': clickHandler }"
    >
      <ParkingSpaceListItem
        :parkingSpace="space"
        :markerText="createMarkerLabel(index + 1)"
        :t="t"
        :distance="space.distance ? `${space.distance}m` : undefined"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ParkingSpaceListItem from "./ParkingSpaceListItem";

export default {
  name: "ParkingSpaceList",
  components: { ParkingSpaceListItem },
  props: {
    clickHandler: {
      type: Function,
      default: () => {},
    },
    limit: {
      type: Number,
      default: undefined,
    },
    distancePoint: {
      type: Object,
      default: null,
    },
    cityZoneId: {
      type: String,
      required: true,
    },
    t: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      spaces: "parkingSpaces/parkingSpaces",
      spacesDistance: "parkingSpaces/parkingSpacesDistance",
    }),
    parkingSpaces() {
      return (this.distancePoint ? this.spacesDistance(this.distancePoint) : this.spaces).slice(
        0,
        this.limit
      );
    },
  },
  created() {
    this.fetchParkingSpaces({ cityZoneId: this.cityZoneId });
  },
  methods: {
    ...mapActions({ fetchParkingSpaces: "parkingSpaces/fetchParkingSpaces" }),
    createMarkerLabel(index) {
      return this.limit > 1 || this.limit === undefined ? index.toString() : undefined;
    },
  },
};
</script>
